/* 🤖 this file was generated by svg-to-ts */
export const siriusTrash: {
  name: 'trash';
  data: string;
} = {
  name: 'trash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M9.75 9a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 9.75 9ZM15 15.75v-6a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 1.5A2.25 2.25 0 0 0 7.5 3.75v.75H3.75a.75.75 0 0 0 0 1.5h.75v13.5A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5V6h.75a.75.75 0 0 0 0-1.5H16.5v-.75a2.25 2.25 0 0 0-2.25-2.25h-4.5Zm5.25 3v-.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v.75h6ZM6 6v13.5h12V6H6Z" fill="currentColor"/></svg>`
};
